var _defs, _g, _g2, _rect, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPricingHighLow = function SvgPricingHighLow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 164.729 127.247"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pricing_high_low_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f54f4f",
    stroke: "#d34444",
    strokeWidth: 2,
    d: "M0 0h21.033v21.033H0z",
    "data-name": "Rectangle 30079"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "pricing_high_low_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#59ba46",
    stroke: "#4da03c",
    strokeWidth: 2,
    d: "M0 0h21.033v21.033H0z",
    "data-name": "Rectangle 30079"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "pricing_high_low_svg__a",
    width: 136.521,
    height: 127.247,
    x: 0,
    y: 0,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -9,
    dy: 9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.149
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity",
      isolation: "isolate"
    },
    transform: "translate(-1149.651 -393.209)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#pricing_high_low_svg__a)",
    transform: "translate(1149.65 393.21)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#bababa",
    "data-name": "Rectangle 30074",
    transform: "translate(9)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 127.521,
    height: 118.247,
    stroke: "none",
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 126.521,
    height: 117.247,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 4.5
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#cfcfce",
    stroke: "#b1b1b1",
    "data-name": "Rectangle 30078",
    transform: "translate(1164.026 485.103)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 116.385,
    height: 21.033,
    stroke: "none",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 115.385,
    height: 20.033,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 2.5
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 116.385,
    height: 81.329,
    fill: "#8f8f8f",
    "data-name": 18,
    rx: 5,
    transform: "translate(1164.108 398.652)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1851"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1849"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pricing_high_low_svg__b)",
    "data-name": "Group 1848",
    transform: "translate(1293.347 492.719)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#f54f4f",
    "data-name": "Path 17595"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.586 19.833 1.962 11.21h3.245V1.08h10.758V11.21h3.244z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d34444",
    d: "M6.207 2.079V12.21h-1.83l6.209 6.21 6.208-6.21h-1.83V2.08zm-1.625-2h12.007c.208 0 .376.168.376.375v9.756h3.752a.376.376 0 0 1 .265.641L10.851 20.982a.375.375 0 0 1-.53 0L.188 10.851a.375.375 0 0 1 .265-.64h3.753V.453c0-.207.168-.375.375-.375"
  })))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1852"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1850"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pricing_high_low_svg__c)",
    "data-name": "Group 1848",
    transform: "translate(1293.347 393.209)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#59ba46",
    "data-name": "Path 17595"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.965 19.954H5.207V9.823H1.962L10.586 1.2l8.623 8.623h-3.244v10.131"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4da03c",
    d: "M14.965 18.954V8.823h1.83l-6.21-6.209-6.208 6.209h1.83v10.131zm1.624 2H4.582a.375.375 0 0 1-.375-.375v-9.756H.454a.375.375 0 0 1-.265-.64L10.32.05a.375.375 0 0 1 .53 0l10.132 10.131a.375.375 0 0 1-.265.64h-3.752v9.757a.375.375 0 0 1-.376.375"
  }))))))));
};
export default SvgPricingHighLow;